import './editable-field.less';

import React, {useRef} from 'react';
import TextArea from 'antd/lib/input/TextArea';
import {Button, Icon} from 'antd';

export const EditableField = ({ value, editing, onStartEdit, saving, onSave, onCancel }) => {
  const commentTextareaRef = useRef(null);

  return (
    <div className="editable-field">
      {
        editing
          ? (
            <div>
              <TextArea defaultValue={value} ref={commentTextareaRef} autosize />
              <div className="editable-field-input">
                <Button type={'primary'} onClick={() => onSave(commentTextareaRef.current.textAreaRef.value)} loading={saving}>Сохранить</Button>
                {!saving && <Button onClick={onCancel}>Отмена</Button>}
              </div>
            </div>
          )
          : <div className="raw-value">{value}</div>
      }
      {
        !editing && (
          <Button type="link" onClick={onStartEdit} className="edit-icon">
            <Icon type="edit" />
          </Button>
        )
      }
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/editable-field.js